import { useCallback, useEffect } from "react";

import { useLocalizedLocationChangeEffect } from "../Utils/localizedLocation";

import { storeVisitorId } from "../../mutations/StoreVisitorIdMutation";
import { storeLocationVisit } from "../../mutations/StoreLocationVisitMutation";
import { useSelector } from "react-redux";
import { sendToMatomo } from "../Utils/useMatomoTracking";

let visitorId;

export const useVisitorTracker = () => {
  const processVisitorId = useCallback(providedVisitorId => {
    if (visitorId === providedVisitorId) return;

    visitorId = providedVisitorId;
    storeVisitorId({ visitorId });
  }, []);

  // When the Matomo script is loaded, the `viewer.isTracked` store prop is updated to
  // true, which allows us to ensure that we actually register the visitor id when the
  // user accepts the cookies from the banner.
  const isTracked = useSelector(({ viewer }) => viewer?.isTracked);

  useEffect(() => {
    if (!isTracked) return;

    // Note that the `this.getVisitorId` is evaluated in the context of the Matomo object
    // class, and returns the calculated visitor id.
    sendToMatomo(function () {
      processVisitorId(this.getVisitorId());
    });
  }, [processVisitorId, isTracked]);

  // When the location changes, store it in the backend attached to the viewer so its
  // navigation data can be used for debugging purposes
  useLocalizedLocationChangeEffect(({ pathname }) => {
    storeLocationVisit(pathname);
  });
};
